import React from 'react';
import { Language, Theme } from '../types';

interface TermsScreenProps {
  theme: Theme;
  language: Language;
  t: any;
  onBack: () => void;
}

export const TermsScreen: React.FC<TermsScreenProps> = ({ theme, t, onBack }) => {
  const isDark = theme === 'dark';

  return (
    <div className="max-w-5xl mx-auto px-4 pb-8">
      <div className="flex items-center justify-between gap-4">
        <div>
          <button
            type="button"
            onClick={onBack}
            className={`inline-flex items-center gap-2 text-xs uppercase tracking-widest ${isDark ? 'text-slate-400 hover:text-white' : 'text-slate-600 hover:text-slate-900'}`}
          >
            <span aria-hidden="true">←</span>
            {t.accountBack}
          </button>
          <h1 className={`mt-3 text-2xl font-semibold sm:text-3xl ${isDark ? 'text-white' : 'text-slate-900'}`}>
            {t.termsTitle}
          </h1>
          <p className={`mt-2 text-sm ${isDark ? 'text-slate-400' : 'text-slate-600'}`}>
            {t.termsUpdated}
          </p>
        </div>
      </div>

      <div className={`mt-10 text-sm leading-relaxed ${isDark ? 'text-slate-200' : 'text-slate-700'}`}>
        {t.termsSections.map((section: { title: string; body: string }) => (
          <div key={section.title}>
            <h2 className={`mt-8 text-lg font-semibold ${isDark ? 'text-white' : 'text-slate-900'}`}>{section.title}</h2>
            <p className="mt-3">{section.body}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
